<div class="picklist-location-breakdown">
  <ng-container *ngIf="!loading; else loader">
    <h3>Location Breakdown</h3>
    <table class="lum-table lum-table--classic striped">
      <tr class="table__head-row text-gray-600">
        <th>Locations</th>
        <th class="">Quantity</th>
        <!-- <th class="">Sleeves</th> -->
      </tr>
      <tr *ngFor="let location of locations; trackBy: trackById">
        <td class="text-gray-600">{{ location?.locationName }}</td>
        <td class="font-semi-bold text-center">
          {{
            location?.rfqStockLocations
              | picklistLocationTotalQuantity
              | number: '1.0' : 'en-US'
          }}
        </td>
        <!-- <td class="text-end">22</td> -->
      </tr>
    </table>
  </ng-container>

  <ng-template #loader>
    <div class="text-center">Loading...</div>
  </ng-template>
</div>
